require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x.json") })
        }
      }, "path---news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x!./.cache/json/news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x!./.cache/json/news-n-pqij-kd-9-tl-4-o-f-je-0-kd-k-8-x.json
// module chunks = 231608221292675